export default __webpack_public_path__ + "static/media/trust-clg-04.e316fcd9.jpg";